import { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem("enoteca_wishlist")) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("enoteca_wishlist", JSON.stringify(ids));
  }, [ids]);

  const has = (id) => ids.includes(id);
  const toggle = (id) => setIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));
  const count = ids.length;

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, remove, count }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
